import { lazy } from 'react';
import withLazyLoading from '../../hoc/withLazyLoading';
import { createCrumbHandle, validatePermission } from '../../utilities/auth';
import withPostHogTracker from '../../composeRouter';

const FormulaConfiguration = withLazyLoading(() => import('../../pages/FormulaConfiguration'));
const FormulaCreation = lazy(() =>
  import('../../pages/formulas').then(module => ({ default: module.FormulaCreation }))
);
const DynamicFormulaCreation = lazy(() =>
  import('../../pages/formulas').then(module => ({ default: module.DynamicFormulaCreation }))
);
const FormulaListing = lazy(() =>
  import('../../pages/formulas').then(module => ({ default: module.FormulaListing }))
);

const formulaRoutes = [
  {
    path: '/formulaConfiguration/:id',
    element: <FormulaConfiguration />,
    loader: validatePermission('Formula_Configuration_WE'),
    handle: createCrumbHandle('Formula Configuration'),
  },
  {
    path: '/formula-list',
    handle: createCrumbHandle('Formulas'),
    children: [
      {
        index: true,
        element: withPostHogTracker(<FormulaListing />),
        loader: validatePermission('Formula_Configuration_WE'),
      },
      {
        path: 'formula-creation/:formulaId?',
        element: withPostHogTracker(<FormulaCreation />),
        loader: validatePermission('Formula_Configuration_WE'),
        handle: createCrumbHandle('Create Formula'),
      },
      {
        path: 'dynamic-formula-creation/:dynamicFormulaId?',
        element: <DynamicFormulaCreation />,
        loader: validatePermission('Formula_Configuration_WE'),
        handle: createCrumbHandle('Create Dynamic Formula'),
      },
    ]
  },
];

export default formulaRoutes;
